import { Box, Tab, Tabs } from '@mui/material';
import { translateCommentLanguage } from 'data/data';
import MenuInfo from 'data/menu';
import usePermission from 'hooks/usePermission';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

function LinkTab(props) {
    const {href, ...restProps} = props;
    let navigate = useNavigate();
    return (
        <Tab
            sx={{
                fontWeight: "bold", fontSize: "16px", backgroundColor: "#c1c1c1", borderRadius: "unset", color: "#fff", border: "unset",
                "&.Mui-selected" : {backgroundColor: "#177ddc",borderRadius: "unset", color: "#fff"},
            }}
            onClick={() => { navigate(href); }}
            {...restProps}
        />
    );
}

export default function MonitoringSettingTabsLayout(props) {
    const { t } = useTranslation();
    const { menuId } = props;
    const tabs = MenuInfo.ROOT.find(menuId);
    const fullpath = useLocation().pathname;

    const { hasPermission, isPermissionReady, isMenuVisible } = usePermission();
    if (!isPermissionReady) {
        return null;
    }
    const visibleMenus = tabs.children.filter(menu => {
        const permissionOk =
            !menu.permission || hasPermission(menu.permission);

        const featureOk =
            menu.feature === undefined || menu.feature;

        return permissionOk && featureOk;
    });
    const tabsVisible = isMenuVisible(tabs);

    return (
        <>
        <div className="mobile_navi" style={{color:"#000"}}>
        {
            translateCommentLanguage(((visibleMenus.find((child) => child.isActive)?.fullpath === fullpath) ? visibleMenus.find((child) => child.isActive).element.props.comment : ""),t)
        }
        </div>

        {(visibleMenus && visibleMenus.length > 1) ?
        <>
        {tabsVisible && 
        <Box sx={{ width: '100%', "& .MuiBox-root": {borderColor:"rgba(255, 255, 255, 0.05)"} }} className="mrosetup_tabs">
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={tabs.activeChildIndex()} aria-label="basic tabs example">
                    {
                        visibleMenus.map(child => {
                            return (<LinkTab key={child.id} label={t(child.name)} href={child.fullpath}/>)
                        })
                    }
                </Tabs>
            </Box>
        </Box>
        }
        <Outlet/>
        </>
        :
        <Outlet/>
        }
        </>
    )
}